import api from 'services/system/profile'

export const getProfiles = async () => {
  let res = await api.list()

  return res?.data?.data ?? []
}
